import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import {duration} from '@material-ui/core/styles/transitions';

const defaultTransitionDuration = {enter: duration.enteringScreen, exit: duration.leavingScreen};

class Confirm extends React.Component {
  static displayName = 'Confirm';

  static propTypes = {
    cancelButtonProps: PropTypes.object,
    cancelButtonText: PropTypes.string,
    cancelButtonDataId: PropTypes.string,
    confirmButtonProps: PropTypes.object,
    confirmButtonText: PropTypes.string,
    confirmButtonDataId: PropTypes.string,
    children: PropTypes.node,
    dialogContentProps: PropTypes.object,
    header: PropTypes.node,
    hideCancel: PropTypes.bool,
    hideConfirm: PropTypes.bool,
    maxWidth: PropTypes.string,
    message: PropTypes.node,
    messageDataId: PropTypes.string,
    modalDataId: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onCancel: PropTypes.func,
    onClick: PropTypes.func,
    onConfirm: PropTypes.func,
    title: PropTypes.node,
    transitionDuration: PropTypes.object,
  };

  static defaultProps = {
    cancelButtonText: 'Cancel',
    confirmButtonText: 'Confirm',
    hideCancel: false,
    hideConfirm: false,
  };

  static wrapString = (content, Component) => {
    if (_.isString(content)) {
      return <Component>{content}</Component>;
    }
    return content;
  }

  render() {
    const content = this.props.children || this.props.message;
    return (
      <Dialog
        fullWidth
        maxWidth={this.props.maxWidth || 'sm'}
        open={this.props.open}
        onClose={this.props.onCancel}
        onClick={this.props.onClick}
        transitionDuration={this.props.transitionDuration || defaultTransitionDuration}
      >
        <div data-id={this.props.modalDataId ? this.props.modalDataId : 'confirm-dialog'}>
          {this.props.header}
          {this.props.title &&
            Confirm.wrapString(this.props.title, DialogTitle)
          }
          {content &&
            <DialogContent
              data-id={this.props.messageDataId ? this.props.messageDataId : 'message'}
              {...this.props.dialogContentProps}
            >
              {Confirm.wrapString(content, DialogContentText)}
            </DialogContent>
          }
          {!(this.props.hideCancel && this.props.hideConfirm) &&
            <DialogActions>
              {!this.props.hideCancel &&
                <Button
                  color={this.props.hideConfirm ? 'primary' : 'default'}
                  data-id={
                    this.props.cancelButtonDataId ? this.props.cancelButtonDataId : 'cancel-button'
                  }
                  variant={this.props.hideConfirm ? 'contained' : 'text'}
                  {...this.props.cancelButtonProps}
                  onClick={this.props.onCancel}
                >
                  {this.props.cancelButtonText}
                </Button>
              }
              {!this.props.hideConfirm &&
                <Button
                  color="secondary"
                  data-id={
                    this.props.confirmButtonDataId ?
                      this.props.confirmButtonDataId : 'confirm-button'
                  }
                  variant="contained"
                  {...this.props.confirmButtonProps}
                  onClick={this.props.onConfirm}
                >
                  {this.props.confirmButtonText}
                </Button>
              }
            </DialogActions>
          }
        </div>
      </Dialog>
    );
  }
}

export default Confirm;



// WEBPACK FOOTER //
// ./src/common/components/Confirm/Confirm.js